module.exports = __webpack_public_path__ + "static/how-it-works-hero-f02587c10a75901a55bc890b395ff9e2.png";